import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BulkUpdateDynamicBase, BulkUpdateOption } from '../../../UI-Lib/Bulk-Update/bulkUpdateDynamicBase.component';
import { IWeissmanModalComponent } from '../../../Compliance/WeissmanModalService';
import { BusyIndicatorMessageManager, BusyIndicatorService } from '../../../Busy-Indicator';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { lastValueFrom } from 'rxjs';
import { RentRollRepository } from '../rentRoll.repository';

export interface RentRollBulkUpdateParams {
    companyId: number;
    siteId?: number;
    selection: Compliance.SelectedRowsModel;
    selectedCount: number;
    endDate?: Date;
}

@Component({
    selector: 'rent-roll-bulk-update',
    templateUrl: '../../../UI-Lib/Bulk-Update/bulkUpdateDynamicBase.component.html',
    standalone: false
})
export class RentRollBulkUpdateComponent extends BulkUpdateDynamicBase<RentRollBulkUpdateParams, any> implements OnInit, IWeissmanModalComponent<RentRollBulkUpdateParams, boolean> {
    constructor(
        private readonly _busyIndicatorService: BusyIndicatorService,
        private readonly _rentRollRepository: RentRollRepository,
        _bsModalRef: BsModalRef,
        _fb: UntypedFormBuilder
    ) {
        super(_bsModalRef, _fb);
    }

    @ViewChild('picklist', { static: true }) picklistTemplate: ElementRef;

    params: RentRollBulkUpdateParams;
    result: boolean = false;
    busyIndicatorMessageManager = new BusyIndicatorMessageManager<string>();
    isSaving: boolean = false;

    ngOnInit(): void {
        this.header = `Bulk Update ${this.params.selectedCount} Records`;

        this._templateMap = new Map([
            [Core.DescriptorFieldTypes.Picklist, this.picklistTemplate]
        ]);

        const isValidatedControl = new UntypedFormControl(null);
        isValidatedControl.disable();
        this.bulkUpdateForm.addControl('isValidated', isValidatedControl);

        this.updateOptions.push({
            name: 'Validate',
            isRequired: true,
            template: this._templateMap.get(Core.DescriptorFieldTypes.Picklist),
            picklist: [
                { value: true, name: 'Validated' } as Compliance.NameValuePair<boolean>,
                { value: false, name: 'Not Validated' } as Compliance.NameValuePair<boolean>
            ],
            action: Core.RentRollLineItemBulkUpdateActionEnum.NoChange,
            hiddenField: Core.RentRollLineItemBulkUpdateActionEnum.RemoveOverride,
            formControlName: 'isValidated',
            formControl: isValidatedControl
        } as BulkUpdateOption);
    }

    async save(): Promise<void> {
        this.isSaving = true;
        await this._bulkUpdate();
    }

    cancel() {
        this._bsModalRef.hide();
    }

    private async _bulkUpdate(): Promise<void> {
        const busyRef = this._busyIndicatorService.show({ message: 'Saving' });

        const formValues = this.bulkUpdateForm.value;
        try {
            const model: Core.RentRollLineItemBulkUpdateModel = {
                selectedRows: this.params.selection,
                siteId: this.params.siteId,
                endDate: this.params.endDate,
                isValidatedAction: this.updateOptions[0].action,
                isValidated: formValues['isValidated']
            };

            this.result = await lastValueFrom(this._rentRollRepository.bulkUpdate(this.params.companyId, model));

            this.result = true;
            this._bsModalRef.hide();
        } finally {
            this.isSaving = false;
            await busyRef.hide();
        }
    }
}
